import BaseModel from '../core/BaseModel'
export default class ViewDistrictModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_district",
                tableName: 'view_district'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}